<div class="container">
  <div class="title">
    {{documentTypeLabel}}
  </div>

  @if (document != null) {
    <div class="existing-document-row">
      <a class="customLink" (click)="onDownloadFileClicked(document)">
        <div class="filename">{{document.filename}}</div>
      </a>
      <button class="action-button" mat-button mat-stroked-button color="warn"
        [disabled]="document.isDeleting" (click)="onDeleteButtonClicked(document)">
        <mat-icon>delete</mat-icon>
        Delete
      </button>
    </div>
  }

  <div class="document-upload-row">
    @if (documentPendingUpload.file != undefined) {
      <div class="existing-document-row">
        <a class="customLink" (click)="downloadPendingUpload(documentPendingUpload)">
          <div class="filename">{{documentPendingUpload.file.name}}</div>
        </a>
        @if (!documentPendingUpload.uploading) {
          <button class="action-button" mat-button mat-stroked-button color="warn" [disabled]="uploading"
            (click)="removePendingUpload(documentPendingUpload)">
            <mat-icon>delete</mat-icon>
            Delete
          </button>
        }
        @if (documentPendingUpload.uploading) {
          <div class="upload-spinner">
            <div class="upload-spinner__content">
              <div>Uploading</div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
        }
      </div>
    }

    @if (document == null && documentPendingUpload.file == undefined) {
      <div class="filename no-document-message">
        No documents on File
      </div>
    }

    @if (document == null && documentPendingUpload.file == undefined) {
      <button class="action-button" mat-button mat-raised-button color="primary"
        (click)="fileUpload.click()">
        <mat-icon>cloud_upload</mat-icon> Upload
      </button>
    }

    <input class="file-input" type="file" [accept]="allowedDocumentTypes" (change)="onFileSelected($event)"
      #fileUpload>
    </div>
  </div>